import styled from "styled-components";
export const TopHeading = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: clamp(11px, 0.781vw, 15px);
  align-items: center;
  padding: clamp(10px, 0.833vw, 16px) 0;

 

  h4 {
    font-size: clamp(12px, 0.833vw, 16px);
    /* line-height: 24px; */
    letter-spacing: 0.005em;
    color: #005586;
    font-family: "latobold";
    margin: clamp(3px, 0.26vw, 5px) 0;
  }
  p {
    font-size: clamp(10px, 0.729vw, 14px);
    /* line-height: 19px; */
    letter-spacing: 0.005em;
    color: rgba(17, 17, 17, 0.8);
    margin: clamp(3px, 0.26vw, 5px) 0;
  }
`;
export const ManageOrderTopHeading = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: clamp(11px, 0.781vw, 15px);

  align-items: flex-start;
  padding: clamp(10px, 0.833vw, 16px) 0;
  .icon-text-wrapper {
      display: flex;
      align-items: center;
      gap: 10px;
      > svg {
    width: clamp(28px, 1.979vw, 38px);
    height: clamp(28px, 1.979vw, 38px);
  }
    }
 
  h4 {
    font-size: clamp(12px, 0.833vw, 16px);
    -webkit-letter-spacing: 0.005em;
    -moz-letter-spacing: 0.005em;
    -ms-letter-spacing: 0.005em;
    letter-spacing: 0.005em;
    color: #005586;
    font-family: "latobold";
    margin: clamp(3px, 0.26vw, 5px) 0;
  }
  p {
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.005em;
    color: rgba(17, 17, 17, 0.8);
    margin: 5px 0;
  }
`;
export const OuterWrapper = styled.div`
  padding: 0 clamp(60px,4.688vw,90px) 30px;
  min-height: calc(100vh - 82px);
  max-width: 1920px;
  margin: 0 auto;

  /* .form-wrapper {
        max-width: 1752px;
            margin: 0 auto; 
    } */
`;
export const TabsWrapper = styled.div`
  .MuiTab-root.Mui-selected {
    background: #dcedf7;
    border: 1px solid #ececee;
    border-radius: 4px 4px 0px 0px;
    color: #0a5587;
  }
  .MuiTab-root {
    color: rgba(17, 17, 17, 0.3);
    text-transform: capitalize;
    font-size: clamp(12px,0.833vw,16px);
    /* padding-bottom: 20px; */
    padding: clamp(13px,0.885vw,17px) clamp(14px,0.833vw,16px) clamp(20px,1.458vw,28px);
    font-family: "latosemibold";
  }
  .MuiTabs-indicator {
    border-bottom: clamp(2px,0.208vw,4px) solid #0a5587;
  }
  .MuiTabs-flexContainer {
    > button {
      margin-right: clamp(19px,1.302vw,25px);
      :last-child {
        margin-right: 0;
      }
    }
  }
  .MuiBox-root {
    padding: 0;
  }
`;

export const ChartHeader = styled.div`
  padding: clamp(14px, 0.833vw, 16px) 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: clamp(55px, 3.385vw, 65px);
  .header-btn-group {
    background: #c4c4c44d;
    border-radius: 3px 0px 0px 3px;
    button {
      padding: 0 clamp(15px, 1.042vw, 20px);
      min-height: clamp(25px, 1.719vw, 33px);
      background: transparent;
      color: #00000099;
      font-size: clamp(10px, 0.677vw, 13px);
      font-family: "latosemibold";
      border: none;
      &.active {
        background: linear-gradient(90deg, #55c416 0%, #367910 100%);
        border-radius: 4px;
        color: #fff;
      }
    }
  }
  h4 {
    font-size: clamp(12px, 0.833vw, 16px);
    /* line-height: 24px; */
    font-family: "latobold";
    color: rgb(0, 85, 134);
  }
`;
